<script>
import { FormWizard, TabContent } from "vue-form-wizard";

import instructions from "@/components/step-volunteer-works-center/volunteer-activities/instructions";
import basic_info from "@/components/step-volunteer-works-center/volunteer-activities/basic-info";
import volunteer_works from "@/components/step-volunteer-works-center/volunteer-activities/volunteer-works";

import VolunteerActivitiesModel from "../../../model/volunteer-activities";
import VolunteerActivitiesServices from "../../../services/volunteer-activities";
import { swal } from "../../../helpers/handle_error.js";
import AlertError from "@/components/alert_error";
import VueQRCodeComponent from "vue-qrcode-component";
import html2canvas from "html2canvas";
import notes from "@/components/step-volunteer-works-center/volunteer-activities/notes";

export default {
  components: {
    FormWizard,
    TabContent,
    instructions,
    basic_info,
    volunteer_works,
    notes,
    AlertError,
    "qr-code": VueQRCodeComponent,
  },
  data() {
    return {
      //Page errors.
      errors: [],

      isPrintedInformation: false,
      fullName: "",
      Id: "",
      date: "",
      qrCodeContent: "",
      showAlert: false,
    };
  },
  methods: {
    handleError(error) {
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    resetForm() {
      this.errors = [];
      swal.close();
    },
    onComplete: function () {
      swal.loading();

      var data = new VolunteerActivitiesModel(
        this.$refs["instructions"],
        this.$refs["basic_info"],
        this.$refs["volunteer_works"]
      );
      VolunteerActivitiesServices.addActivities(data.toFormData())
        .then((response) => {
          let data = response.data.data;

          this.fullName = data.fullName;
          this.Id = data.id;
          this.date = data.date;

          this.qrCodeContent = JSON.stringify({
            Id: this.Id,
            fullName: this.fullName,
            date: this.date,
          });

          this.isPrintedInformation = true;
          this.resetForm();
        })
        .catch((error) => {
          this.handleError(error);
          swal.close();
        });
    },
    validateStep(name) {
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model);
      }
    },
    // print card
    async printThis() {
      const el = this.$refs.printcontent;
      const options = { type: "dataURL" };
      const printCanvas = await html2canvas(el, options);
      const link = document.createElement("a");
      link.setAttribute("download", this.Id + ".jpg");
      link.setAttribute(
        "href",
        printCanvas.toDataURL("image/jpg").replace("image/jpg", "image/octet-stream")
      );
      link.click();
    },
  },
  mounted() {},
};
</script>

<template>
  <div style="overflow-x: hidden">
    <!-- Features start -->
    <section
      class="section"
      id="features"
      style="min-height: calc(100vh - 163px); padding-top: 40px; overflow: hidden"
    >
      <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

      <img
        class="bg-pattern d-none d-md-block"
        src="@/assets/images/gg.png"
        alt
        width=""
      />
      <img
        class="bg-pattern d-sm-block d-md-none"
        src="@/assets/images/hh.png"
        alt
        width=""
      />
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="text-center mb-5">
              <a href="/home/index">
                <img src="@/assets/images/name-logo.png" alt width="200" />
              </a>
              <h5>
                <div class="small-title mt-2">الدعم التطوعي</div>
              </h5>
            </div>
          </div>
          <div v-if="isPrintedInformation" class="text-center print-cover">
            <div class="card-print con-print text-center" ref="printcontent">
              <h5>الدعم التطوعي</h5>
              <p><strong>الاسم :</strong> {{ fullName }}</p>
              <p><strong>تاريخ التقديم :</strong> {{ date }}</p>
              <p><strong>رقم الاستمارة :</strong> {{ Id }}</p>
              <qr-code class="qr-code" :text="qrCodeContent"></qr-code>
              <hr />
              <div class="">
                <p class="mb-1">مركز العمل التطوعي</p>
              </div>
            </div>
            <button
              type="button"
              id="btn3"
              @click="printThis"
              class="btn bg-color-violet font-color-white btn-sm mt-2"
            >
              حفظ وصل التسجيل
            </button>
          </div>
          <div v-else class="col-lg-12">
            <div class="mb-5">
              <form-wizard
                color="#7e56a1"
                error-color="#a94442"
                step-size="xs"
                back-button-text="السابق"
                next-button-text="التالي"
                finish-button-text="ارسال البيانات"
                class="form-wizard"
                @on-complete="onComplete"
              >
                <tab-content
                  title="تعليمات التقديم"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('instructions')"
                >
                  <instructions
                    ref="instructions"
                    @on-validate="mergePartialModels"
                  ></instructions>
                </tab-content>

                <tab-content
                  title="معلومات المنسق"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('basic_info')"
                >
                  <basic_info
                    ref="basic_info"
                    @on-validate="mergePartialModels"
                  ></basic_info>
                </tab-content>
                <tab-content
                  title="معلومات البرنامج او النشاط"
                  icon="mdi mdi-chevron-double-left"
                  :before-change="() => validateStep('volunteer_works')"
                >
                  <volunteer_works
                    ref="volunteer_works"
                    @on-validate="mergePartialModels"
                  ></volunteer_works>
                </tab-content>
                <tab-content
                  title="ارسال البيانات"
                  icon="mdi mdi-checkbox-marked-circle-outline"
                  :before-change="() => validateStep('notes')"
                >
                  <notes ref="notes" @on-validate="mergePartialModels"></notes>
                  <h4 class="my-5 text-center">
                    اضغط على ( ارسال البيانات ) لارسال الاستمارة .
                  </h4>
                </tab-content>
              </form-wizard>
            </div>
          </div>
        </div>
        <!-- end row -->
      </div>
      <!-- end container -->
    </section>
    <!-- Features end -->

    <!-- Footer start -->
    <footer class="landing-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <img src="@/assets/images/white-logo.png" alt height="25" />
            <span class="mx-2">مركز العمل التطوعي</span>
          </div>
          <div class="col-md-6">
            <p class="mt-1 text-md-end d-sm-block">
              {{ new Date().getFullYear() }} © جميع الحقوق محفوظة
            </p>
          </div>
        </div>
      </div>
    </footer>
    <!-- Footer end -->
  </div>
</template>
